import { Fragment } from 'react'

import dayjs from 'dayjs'
import { ItemDateRange } from 'globalTypes'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'

import styles from './index.module.css'

export interface Props {
  content: ItemDateRange
  isOnPage?: boolean
}

library.add(faCalendarDays)

const DateRange = ({ content, isOnPage = false }: Props) => {
  dayjs.extend(customParseFormat)
  dayjs.extend(localizedFormat)
  dayjs.locale('it')

  const start = dayjs(content.start, 'YYYY-MM-DD HH:mm:ss')
  const end = dayjs(content.end, 'YYYY-MM-DD HH:mm:ss')

  const isSameDate = start.isSame(end, 'date')

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.iconContainer}>
          <FontAwesomeIcon
            className={styles.icon}
            icon={['fas', 'calendar-days']}
          />
        </div>
      </div>
      <div className={isOnPage ? 'text-sm' : 'text-xs'}>
        {isSameDate ? (
          <Fragment>
            {start.format('LL')}
            <span className="text-gray-500">, da </span>
            {start.format('LT')}
            <span className="text-gray-500"> a </span>
            {end.format('LT')}
          </Fragment>
        ) : (
          <Fragment>
            <span className="text-gray-500">da </span>
            {start.format('LLLL')}
            <span className="text-gray-500"> a </span>
            {end.format('LLLL')}
          </Fragment>
        )}
      </div>
    </div>
  )
}

export default DateRange
